import SiteTheme from "../model/SiteTheme";
import NavigationSet from "../model/NavigationSet";

const _common_links: NavigationSet = {
    Home: '/',
    "Site Info": {
        Contact: '/contact'
    }
};

const DefaultTheme: SiteTheme = {
    bannerImage: '',
    bannerImageCircular: true,
    bannerTitle: '',
    bannerTitleAlt: "",
    navigationLinks: _common_links,
    fullReloadLinks: []
};

export default DefaultTheme;